import { Component } from '@angular/core';
import {OrderDetailItemsComponent} from "@spartacus/order/components";
import {Observable, of} from "rxjs";
import {GonvarriOrder} from "../../core/models/gonvarri-order.model";
import {tap} from "rxjs/operators";
import {Order} from "@spartacus/order/root";

@Component({
    selector: 'cx-order-details-items',
    templateUrl: './gonvarri-order-detail-items.component.html',
    styleUrl: './gonvarri-order-detail-items.component.scss',
    standalone: false
})
export class GonvarriOrderDetailItemsComponent extends OrderDetailItemsComponent {

  public override order$: Observable<GonvarriOrder> = this.orderDetailsService.getOrderDetails().pipe(
    tap((order: Order) => {
      this.pickupConsignments = this.getGroupedConsignments(order, true);
      this.deliveryConsignments = this.getGroupedConsignments(order, false);

      this.pickupUnconsignedEntries = this.getUnconsignedEntries(order, true);
      this.deliveryUnConsignedEntries = this.getUnconsignedEntries(
        order,
        false
      );
    })
  ) as any;

  getReplenishmentOrderCode(order: any): boolean {
    return order.replenishmentOrderCode;
  }

  getEnableAddToCart(enableAddToCart: any): boolean {
    return enableAddToCart;
  }

  getConsignments(consignments: any): any {
    return consignments;
  }

}
